exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logo[data-v-56ba9ff6] {\n  max-width: 48px;\n}\n.q-tab.nav-tab[data-v-56ba9ff6] {\n  min-height: 49px;\n}\n#top-avatar[data-v-56ba9ff6] {\n  cursor: pointer;\n}\n@media (min-width: 600px) {\n.logo[data-v-56ba9ff6] {\n    max-width: 64px;\n}\n.q-tab.nav-tab[data-v-56ba9ff6] {\n    min-height: 63px;\n}\n}\n", ""]);

